/**
 * Shown when the content request failed.
 *
 * Deliberately separate from the empty state: an outage and a customer whose
 * areas have no pages yet are different facts, and telling someone "there is no
 * help" when the server is down is both wrong and unactionable. This one offers
 * a retry.
 */

import { Typography } from "@/components/common/Typography/Typography"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconRefresh } from "@tabler/icons-react"

export function HelpdeskErrorState({ onRetry }: { onRetry: () => void }) {
  const { translate } = useTranslation()

  return (
    <div className="flex h-full items-center justify-center px-XXL py-XL">
      <div className="max-w-md text-center">
        <Typography as="h1" variant="titleM" className="pb-S">
          {translate("HELPDESK/ERROR_TITLE")}
        </Typography>
        <Typography as="p" variant="textS" className="pb-L text-grey5">
          {translate("HELPDESK/ERROR_BODY")}
        </Typography>
        <Button size="sm" onClick={onRetry}>
          <IconRefresh size={15} stroke={1.75} />
          {translate("HELPDESK/RETRY")}
        </Button>
      </div>
    </div>
  )
}
